import React from "react";

export default function OverlayInactividad({ visible }) {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/25 backdrop-blur-[1px] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl px-7 py-6 w-[90%] max-w-md text-center border-t-4 border-[#008043]">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full border-4 border-[#008043] flex items-center justify-center">
          <div className="h-4 w-4 rounded-full bg-[#C2D500]" />
        </div>

        <h2 className="text-[#008043] text-xl font-bold">
          Sesión inactiva
        </h2>

        <p className="mt-2 text-sm text-gray-700">
          Tu sesión se cerrará por inactividad.
        </p>

        <p className="mt-1 text-xs text-gray-500">
          Mové el mouse o presioná una tecla para continuar.
        </p>
      </div>
    </div>
  );
}